import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/Home'
import Ourproducts from "@/pages/Ourproduct"
import Ourservices from "@/pages/Ourservice"
import OurCostumer from "@/pages/OurCostumer"
import contactACS from "@/pages/ContactUSACS"
import ForkProd from "@/pages/ForkliftProd.vue"
import OilProd from "@/pages/OilFuchsProd.vue"
import TireProd from "@/pages/TyresProd.vue"
import ProductPage from "@/components/ProductPages"

// 1. Use plugin.
// This installs <router-view> and <router-link>,
// and injects $router and $route to all router-enabled child components
Vue.use(VueRouter)

// 3. Create the router
const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  linkActiveClass : 'active',
  routes: [
    { path: '/', component: Home },
    { path: '/Home/MarketDetail', component: Home},
    { path: '/Ourproduct', component: Ourproducts },
    { path: '/OurService', component: Ourservices },
    { path: '/OurCostumer', component: OurCostumer },
    { path: '/ContactUSACS', component: contactACS },
    { path: '/ForkliftProd', component: ForkProd},
    { path: '/OilFuchsProd', component: OilProd},
    { path: '/TyresProd', component: TireProd},
    { path: '/ProductPages', component: ProductPage},

    
  ]
})

export default router
